module.exports = new __parcel__URL__("96537_h.dfdeb3f4.jpg").toString();